module.exports = __webpack_public_path__ + "static/27deb6955bb944fe9518726d114fb6a2c32e685dea99f5381fb80c566626a54c-185d5c59dd08fdb4cd621ad671c6ca2c.png";